
export default {
  name: 'GermanIconComponent',
  props: {
    classCss: { type: String, default: '' },
  },
}
